module.exports = __webpack_public_path__ + "img/error.7641010e.svg";